<style scoped>
    .search-input{
        display: inline-block;
        min-width: 250px;
        max-width: 600px;
    }
</style>
<template>
  <div>
    <div class="line text-center">
      <div class="search-input">
        <Input
          v-model="params.search"
          placeholder="请输入搜索关键字"
          @on-enter="doSearch"
        />
      </div>
      <Ajaxbtn
        ref="searchBtn"
        :url="get_pre_customers_path"
        :params="params"
        type="search"
        @before="beforeSearch"
        @done="handleData"
        @fail="handleFail"
      />
    </div>
    <div class="list-container">
      <Table
        ref="table"
        :columns="pre_customer_columns"
        :data="pre_customers"
        :no-data-text="empty_tip"
        size="small"
      />
      <Backdrop v-show="loading" />
    </div>
    <div
      v-show="page_info.total"
      class="line paginate-fix-bottom"
    >
      <Page
        show-total
        show-elevator
        :current="page_info.current"
        :total="page_info.total"
        :page-size="page_info.page_size"
        @on-change="pageChange"
      />
    </div>
    <br>
    <div class="line text-bold">
      请将此 [地址] 或 [二维码] 发给需要填写信息的员工
    </div>
    <!--<div class="line">-->
    <!--<Button size="small" icon="ios-copy-outline" @click="copyLink">复制链接</Button>-->
    <!--<Button size="small" icon="ios-copy-outline">复制二维码</Button>-->
    <!--</div>-->
    <div class="line">
      <a
        ref="link"
        href="https://mis.baicizhan.com/web/pre_customer/add"
        target="_blank"
      >https://mis.baicizhan.com/web/pre_customer/add</a>
    </div>
    <div class="line">
      <qrcode
        value="https://mis.baicizhan.com/web/pre_customer/add"
        :size="250"
      />
    </div>

    <Modal
      v-model="insert_config.modal"
      width="750"
      title="操作员工入职"
      ok-text="确定入职"
      :loading="insert_config.loading"
      @on-ok="turnIntoCustomer"
    >
      <div class="line">
        <Row>
          <i-col span="8">
            <Select
              v-model="extra_info.customer_type"
              transfer
              placeholder="员工类别"
            >
              <Option :value="0">
                正式员工
              </Option>
              <Option :value="1">
                正式员工-实习
              </Option>
              <Option :value="10">
                实习生
              </Option>
              <Option :value="20">
                兼职/外包
              </Option>
              <Option :value="30">
                挂靠人员
              </Option>
            </Select>
          </i-col>
          <i-col span="8">
            <i-input v-model="extra_info.uid">
              <span slot="prepend">工号</span>
              <span
                v-show="!extra_info.uid"
                slot="append"
              >
                <Button @click="getAutoUid()">编号</Button>
              </span>
            </i-input>
          </i-col>
        </Row>
      </div>
      <Row>
        <i-col span="6">
          <div class="form-title">
            公司
          </div>
          <Select
            v-if="companies.length"
            v-model="extra_info.company_id"
            transfer
            placeholder="选择公司"
          >
            <Option
              v-for="c in companies"
              :key="c.id"
              :value="c.id"
            >
              {{ c.short_name }}
            </Option>
          </Select>
        </i-col>
        <i-col span="6">
          <div class="form-title">
            团队
          </div>
          <Select
            v-if="teams.length"
            v-model="extra_info.team_id"
            transfer
            filterable
            placeholder="选择团队"
          >
            <Option
              v-for="t in teams"
              v-show="!t.del"
              :key="t.id"
              :value="t.id"
            >
              {{ t.full_name }}
            </Option>
          </Select>
        </i-col>
        <i-col span="6">
          <div class="form-title">
            岗位
          </div>
          <Select
            v-if="jobs.length"
            v-model="extra_info.job_id"
            transfer
            filterable
            placeholder="选择岗位"
          >
            <Option
              v-for="j in jobs"
              v-show="!j.del"
              :key="j.id"
              :value="j.id"
            >
              {{ j.name }}
            </Option>
          </Select>
        </i-col>
        <i-col span="6">
          <div class="form-title">
            工作地点
          </div>
          <Select
            v-if="offices.length"
            v-model="extra_info.office_id"
            transfer
            placeholder="工作地点"
          >
            <Option
              v-for="o in offices"
              :key="o.id"
              :value="o.id"
            >
              {{ o.name }}
            </Option>
          </Select>
        </i-col>
      </Row>
    </Modal>

    <Modal
      v-model="edit_config.modal"
      width="600"
      title="更改信息"
      ok-text="保存"
      :loading="edit_config.loading"
      @on-ok="editOk"
    >
      <Form
        ref="form"
        :model="edit_pre_customer"
        :label-width="50"
      >
        <FormItem
          label="卡号"
          prop="bank_number"
          :rules="{required: true, validator: validateBankNumber}"
        >
          <i-input
            v-model.trim="edit_pre_customer.bank_number"
            placeholder="银行卡号"
          />
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>
<script route="/hr/pre_customer">
  import Util from '../../libs/util';
  import PreCustomerExpand from './components/pre_customer_expand';
  import {mapGetters} from "vuex";
  export default {
    /* router_info_start */
    router_info: '/hr/pre_customer',
    /* router_info_end */

    components: { PreCustomerExpand },
    data() {
      return {
        get_pre_customers_path: Util.api.query_pre_customer,
        params: {
          per_page: 10,
          page: 1,
          search: ''
        },
        empty_tip: '',
        page_info: {
          current: 1,
          total: 0,
          page_size: 10
        },
        insert_config: {
          modal: false,
          loading: true
        },
        edit_config: {
          modal: false,
          loading: true
        },
        pre_customers: [],
        pre_customer_columns: [
          {
            title: '展开',
            align: 'center',
            type: 'expand',
            width: 50,
            render: (h, params) => {
              const row = params.row;
              return h(PreCustomerExpand, {
                props: {
                  pre_customer: row
                }
              })
            }
          },
          {
            title: '姓名',
            //fixed: 'left',
            key: 'account',
            width: 80,
            align: 'center',
            render: (h, params) => {
              const row = params.row;
              const ret = [];
              ret.push(h('div', row.account));
              if (row.customer_id) {
                ret.push(h('div', {
                  'class': {
                    'color-success': true
                  }
                }, '已入职'));
              }
              if (row.del) {
                ret.push(h('div', {
                  'class': {
                    'color-error': true
                  }
                }, '已废弃'));
              }
              return h('div', ret);
            }
          },
          {
            title: '基本信息',
            minWidth: 190,
            render: (h, params) => {
              const row = params.row;
              const ret = [];
              const gender = params.row.gender ? '男' : '女';
              ret.push(h('div', '性别: ' + gender));
              ret.push(h('div', '手机: ' + (row.mobile || '无')));
              ret.push(h('div', '邮箱: ' + (row.email || '无')));
              ret.push(h('div', '身份证: ' + (row.id_number || '无')));
              ret.push(h('div', 'QQ: ' + (row.qq_number || '无')));
              ret.push(h('div', '微信: ' + (row.wechat_number || '无')));
              return h('div', ret);
            }
          },
          {
            title: '紧急联系人',
            minWidth: 130,
            render: (h, params) => {
              const row = params.row;
              const ret = [];
              ret.push(h('div', '姓名: ' + row.contact));
              ret.push(h('div', '关系: ' + row.contact_relation));
              ret.push(h('div', '手机: ' + row.contact_mobile));
              return h('div', ret);
            }
          },
          {
            title: '合同信息',
            minWidth: 120,
            render: (h, params) => {
              const row = params.row;
              const ret = [];
              ret.push(h('div', '开始: ' + (row.contract_start || '-')));
              ret.push(h('div', '结束: ' + (row.contract_end || '-')));
              return h('div', ret);
            }
          },
          {
            title: '学历信息',
            minWidth: 200,
            render: (h, params) => {
              const row = params.row;
              const ret = [];
              ret.push(h('div', '学校: ' + (row.school || '未设置')));
              ret.push(h('div', '学历: ' + (row.degree || '未设置')));

              let major_attr = '未设置';
              switch (row.major_attr) {
              case 0:
                major_attr = '英语类';
                break;
              case 1:
                major_attr = '其他';
                break;
              case 2:
                major_attr = '教育类';
                break;
              case 3:
                major_attr = '心理类'
              }
              ret.push(h('div', [
                h('span', '专业: ' + (row.major || '未设置')),
                h('span', ' 属性: ' + major_attr)
              ]));
              ret.push(h('div', '院系: ' + (row.faculty || '-')));
              ret.push(h('div', '年级: ' + (row.grade || '-')));
              ret.push(h('div', '学生证到期日期: ' + (row.student_expire || '-')));
              return h('div', ret);
            }
          },
          {
            title: '支付信息',
            minWidth: 160,
            render: (h, params) => {
              const row = params.row;
              const ret = [];
              ret.push(h('div', '银行: ' + (row.bank || '-')));
              ret.push(h('div', '开户行: ' + (row.bank_branch || '-')));
              ret.push(h('div', '开户省: ' + (row.bank_province || '-') + ' 市:' + (row.bank_city || '-')));
              ret.push(h('div', '卡号: ' + (row.bank_number || '-')));
              ret.push(h('div', '支付宝: ' + (row.alipay || '-')));
              return h('div', ret);
            }
          },
          {
            title: '操作',
            fixed: 'right',
            width: 100,
            align: 'center',
            render: (h, params) => {
              const row = params.row;
              const ret = [];
              if (!row.customer_id && !row.del) {
                ret.push(h('Button', {
                  props: {
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.editPreCustomer(row);
                    }
                  }
                }, '编辑卡号'));
                // ret.push(h('div', {'class': {hr: true}}));
                ret.push(h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.selectExtraInfo(row);
                    }
                  }
                }, '入职'));
                // ret.push(h('div', {'class': {hr: true}}));
                ret.push(h('Poptip', {
                  props: {
                    transfer: true,
                    confirm: true,
                    title: "确认废弃吗?"
                  },
                  on: {
                    'on-ok': () => {
                      this.delPreCustomer(row);
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'warning',
                      size: 'small'
                    },
                  }, '废弃')
                ]));
              }
              return h('div', {
                style: {
                  'lineHeight': 2.4
                }
              }, ret);
            }
          }
        ],
        edit_pre_customer: {},
        extra_info: {
          uid: '',
          company_id: 3,
          team_id: 0,
          job_id: 0,
          office_id: 0,
          director_id: 0,
          customer_type: 10
        },
        loading: false
      }
    },
    computed: {
      ...mapGetters({
        companies: 'async/companies',
        companies_hash: 'async/companies_hash',
        teams: 'async/teams',
        teams_hash: 'async/teams_hash',
        jobs: 'async/jobs',
        jobs_hash: 'async/jobs_hash',
        offices: 'async/offices',
        offices_hash: 'async/offices_hash',
      })
    },
    watch: {
      $route(route, oldRoute) {
        if (route.path === oldRoute.path) {
          this.params.page = 1;
          this.getPreCustomers();
        }
      }
    },
    created() {
      this.getPreCustomers();
    },
    mounted() {
      //
    },
    methods: {
      editPreCustomer(pre_customer) {
        this.edit_pre_customer = Util.clone(pre_customer);
        this.edit_config.modal = true;
      },
      validateBankNumber(rule, value, callback) {
        if (!value) {
          callback(new Error('卡号不能为空'));
        } else if (value && /\s/.test(value)) {
          callback(new Error('卡号不能有空格'));
        } else {
          callback();
        }
      },
      editOk() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            Util.ajax.post(Util.api.update_pre_customer, this.edit_pre_customer).then((response) => {
              return response.data;
            }).then((res) => {
              if (res.code === 1) {
                const data = res.data;
                Util.insertOrUpdateArrayItem(this.pre_customers, data);
                this.edit_config.modal = false;
                this.$Message.success('保存成功');
              } else {
                this.$Modal.error({title: '错误', content: res.msg});
              }
            }).catch((e) => {
              this.$Modal.error({title: '错误', content: e.message});
            }).finally(() => {
              this.edit_config.loading = false;
              setTimeout(() => {
                this.edit_config.loading = true;
              }, 500);
            });
          } else {
            this.edit_config.loading = false;
            setTimeout(() => {
              this.edit_config.loading = true;
            }, 500);
            this.$Message.error('表单有误');
          }
        });
      },
      getPreCustomers() {
        if (!this.loading) {
          this.loading = true;
          this.empty_tip = '获取数据中...';
          Util.ajax.get(this.get_pre_customers_path, {
            params: this.params
          }).then((response) => {
            return response.data;
          }).then((res) => {
            this.loading = false;
            if (res.code === 1) {
              const data = res.data;
              this.handleData(data);
            } else {
              this.$Modal.error({
                title: '错误',
                content: res.msg
              });
            }
          }).catch((e) => {
            this.loading = false;
            this.empty_tip = '获取数据失败, 请刷新页面重试';
            console.log(e);
          });
        }
      },
      pageChange(new_page) {
        this.params.page = new_page;
        this.getPreCustomers();
      },
      doSearch() {
        this.$refs.searchBtn.doAjax();
      },
      beforeSearch() {
        this.params.page = 1;
        this.loading = true;
        this.empty_tip = '搜索结果中...';
        this.pre_customers = [];
      },
      handleData(data) {
        this.loading = false;
        this.pre_customers = [];
        data.pre_customers.forEach((customer) => {
          this.pre_customers.push(customer);
        });
        if (data.pre_customers.length === 0) {
          this.empty_tip = '没有结果, 请重试!';
        }
        this.page_info.current = data.cur_page;
        this.page_info.page_size = data.per_page;
        this.page_info.total = data.total_count;
      },
      handleFail(e) {
        this.loading = false;
        this.empty_tip = '搜索失败, 请重试';
        console.log(e);
      },
      getAutoUid() {
        let head_num;
        if (this.extra_info.customer_type < 10) {
          switch (this.extra_info.company_id) {
          case 1:
            head_num = 1;
            break;
          case 2:
            head_num = 2;
            break;
          case 3:
            head_num = 3;
            break;
          default:
            this.$Message.warning('请选择公司后再编号!');
            return;
          }
        } else if (this.extra_info.customer_type === 10) {
          head_num = 4;
        } else if (this.extra_info.customer_type === 20) {
          head_num = 5;
        } else if (this.extra_info.customer_type === 30) {
          head_num = 6;
        } else {
          this.$Message.warning('请选择员工类型!');
          return;
        }
        Util.ajax.get('customer/get_auto_uid', {
          params: {
            head_num: head_num
          }
        }).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            this.extra_info.uid = res.data;
          } else {
            this.$Modal.error({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          console.log(e);
        });
      },
      delPreCustomer(pre_customer) {
        if (!this.deleting) {
          this.deleting = true;
          Util.ajax.post(Util.api.delete_pre_customer, {
            id: pre_customer.id
          }).then((response) => {
            console.log(response);
            return response.data;
          }).then((res) => {
            this.deleting = false;
            if (res.code === 1) {
              const data = res.data;
              Util.insertOrUpdateArrayItem(this.pre_customers, data);
              this.$Message.success({
                content: '删除成功!'
              });
            } else {
              this.$Modal.error({
                title: '错误',
                content: res.msg
              });
            }
          }).catch((e) => {
            this.deleting = false;
            console.log(e);
            this.$Message.error({
              content: '删除失败!'
            });
          });
        }
      },
      selectExtraInfo(pre_customer) {
        this.edit_pre_customer = pre_customer;
        this.insert_config.modal = true;
      },
      turnIntoCustomer() {
        if (this.edit_pre_customer.customer_id) {
          return;
        }
        Util.ajax.post(Util.api.turn_into_customer, {
          pre_customer: this.edit_pre_customer,
          extra_info: this.extra_info
        }).then((response) => {
          console.log(response);
          return response.data;
        }).then((data) => {
          console.log(data);
          if (data.code === 1) {
            this.insert_config.modal = false;
            Util.insertOrUpdateArrayItem(this.pre_customers, data.pre_customer);
            this.$Message.success({
              content: '操作成功!'
            });
          } else {
            this.insert_config.loading = false;
            setTimeout(() => {
              this.insert_config.loading = true;
            }, 500);
            let content = '';
            if (Util.isObject(data.msg)) {
              for (const key in data.msg) {
                content += '<p>' + data.msg[key] + '</p>';
              }
            } else {
              content = data.msg;
            }
            this.$Modal.error({
              title: '提示',
              content: content
            })
          }
        }).catch((e) => {
          this.insert_config.loading = false;
          setTimeout(() => {
            this.insert_config.loading = true;
          }, 500);
          console.log(e);
          this.$Message.error({
            content: '操作失败!'
          });
        });
      },
      copyLink() {
        console.log(this.$refs.link);
        this.$refs.link.select();
        document.execCommand('copy');
      }
    }
  }
</script>
